import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { element } from 'protractor';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-product-session-available-edit',
  templateUrl: './product-session-available-edit.component.html',
  styleUrls: ['./product-session-available-edit.component.scss']
})
export class ProductSessionAvailableEditComponent implements OnInit {
  sessions: any;
  products: Product[];
  product_session_available_dict : {} = null

  constructor(private http: HttpService, private global: GlobalService) {
    this.getCvData();
    this.global.set_master_page_title = 'Session Based Product Availability';
  }

  async getCvData() {
    await this.getSessions();
    await this.getProducts();
    this.initiateDict();
  }

  initiateDict() {
   this.http.getProductAvailabilityForPortal().subscribe((data) => {
    console.log(data);
    this.product_session_available_dict = data;
   })
  }

  getProducts() {
    this.http.getProduct().subscribe((data: Product[]) => {
      console.log(data);
      this.products = data;
    }, (error) => {
      console.log(error);
    });
  }

  async getSessions() {
    await this.http.getSession().toPromise().then((data: []) => {
      console.log(data);
      this.sessions = data;
      return true;
    }).catch((error) => {
      console.log(error);
    });
  }

  onChange(event, session_id, product_id) {
    console.log(event , session_id, product_id);
    const data_dict = {
      'availability': event,
      'session_id': session_id,
      'product_id': product_id
    }
    if (confirm('please confirm')) {
      this.http.changeProductAvailability(data_dict).subscribe((data : string)=> {
        console.log(data);
        this.product_session_available_dict[session_id][product_id] = !this.product_session_available_dict[session_id][product_id]
        console.log(this.product_session_available_dict[session_id][product_id])
        this.global.showSnakeBar(data);
      });
    }
    // else {
    //   console.log(!event);
    //   this.product_session_available_dict[session_id][product_id]=!event
    //   console.log(this.product_session_available_dict[session_id][product_id])
    // }
  }



  ngOnInit() {
  }

}


export interface Product {
  id: number;
  group_id: number;
  unit_id: number;
  unit_name: string;
  quantity: number;
  gst_percent: number;
  mrp: number;
  name: string;
  short_name: string;
  code: string;
  description: string;
}
